"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const native_base_1 = require("native-base");
const React = __importStar(require("react"));
const react_native_1 = require("react-native");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const theme_1 = require("theme");
const Account_1 = require("components/partial/Account");
const Clients_1 = require("components/partial/Clients");
const MyShoppingCart_1 = require("components/partial/MyShoppingCart");
const PurchaseSummary_1 = require("components/partial/PurchaseSummary");
const NewQuote_1 = require("components/partial/NewQuote");
const context_1 = require("components/context");
const constants_1 = require("constants/constants");
const icons_1 = __importDefault(require("constants/icons"));
const native_1 = require("@react-navigation/native");
const NewQuote_2 = require("types/components/partial/NewQuote");
const hooks_1 = require("components/hooks");
const giftWidthBase = 100;
const giftWidthLg = 135;
const Header = ({ navigation, route, discounts }) => {
    const authContext = React.useContext(context_1.AuthContext);
    const [clientData, setClientData] = React.useState(undefined);
    const menuOrLogo = (0, native_base_1.useBreakpointValue)({
        base: <MenuButton />,
        md: <Logo />,
    });
    const getAndSetClientData = async () => {
        const client = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_DATA);
        const clientQuote = await async_storage_1.default.getItem(constants_1.StorageKey.CLIENT_QUOTE_DATA);
        if ((route.name == MyShoppingCart_1.name &&
            route.params.quoteClientId) ||
            (route.name == PurchaseSummary_1.name &&
                route.params.quoteClientId)) {
            setClientData(JSON.parse(clientQuote ?? "{}"));
        }
        else if (route.name == NewQuote_1.name) {
            const params = route?.params;
            const snClient = params?.client;
            if (params.clientType == NewQuote_2.EClientType.CLIENT_EXISTENT) {
                setClientData(snClient ?? JSON.parse(client ?? "{}"));
            }
            else {
                setClientData(undefined);
            }
        }
        else {
            if (client) {
                setClientData(JSON.parse(client ?? "{}"));
            }
        }
    };
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        getAndSetClientData();
    }, [navigation, route.params]));
    React.useEffect(() => {
        const asyncFunc = async () => {
            await getAndSetClientData();
            authContext?.addClientChangeListener(getAndSetClientData);
        };
        asyncFunc();
    }, []);
    const clientTextVariant = (0, native_base_1.useBreakpointValue)({
        base: "h6",
        md: "h5",
    });
    return (<>
			<native_base_1.HStack style={styles.container} p={{ base: 12, md: 15 }}>
				{menuOrLogo}
				{clientData && <TacticoMetaDescuento items={discounts}/>}
				<native_base_1.HStack style={styles.containerProfile}>
					<native_base_1.VStack style={styles.containerProfileTexts} alignItems="flex-end">
						<native_base_1.Pressable onPress={() => {
            navigation.navigate(Clients_1.name);
        }}>
							<native_base_1.Text variant={clientTextVariant} textAlign="end" flex={1} fontFamily={theme_1.Fonts.bold}>
								{clientData?.nombre ?? ""}
							</native_base_1.Text>
						</native_base_1.Pressable>

						{clientData && clientData.visualizarAlertaLineaCredito == true && (<native_base_1.Text style={styles.txtProfileCredit} variant="body7">
								{theme_1.Str.creditLine2D + " " + (clientData?.lineacredito ?? "")}
							</native_base_1.Text>)}
					</native_base_1.VStack>
					<native_base_1.Pressable onPress={() => {
            if (clientData == null)
                return;
            navigation.navigate(Account_1.name);
        }}>
						<native_base_1.Image source={require("images/ic_user_with_back_header.svg")} style={styles.imgProfile} resizeMode="cover" alt="icono de usuario" width={{ base: 42, md: 50 }} height={{ base: 42, md: 50 }}/>
					</native_base_1.Pressable>
				</native_base_1.HStack>
			</native_base_1.HStack>
			<native_base_1.View style={styles.bottomLine}>
				<native_base_1.Image style={styles.imgHeaderLine} source={require("images/ic_header_line.svg")} resizeMode="cover" alt="imagen inferior del header"/>
			</native_base_1.View>
		</>);
};
exports.Header = Header;
const MenuButton = () => {
    const navigation = (0, native_1.useNavigation)();
    return (<native_base_1.Pressable onPress={() => {
            navigation.openDrawer();
        }} p={{ base: 10 }}>
			<native_base_1.Image source={require("images/ic_menu.svg")} w={{ base: 25 }} h={{ base: 25 }} resizeMode="center" alt="menu"/>
		</native_base_1.Pressable>);
};
const Logo = () => {
    return (<native_base_1.Image source={require("images/ic_logo.svg")} w={{ base: 100 }} h={{ base: 50 }} resizeMode="center" alt="logo"/>);
};
const TacticoMetaDescuento = ({ items }) => {
    const client = (0, hooks_1.useClient)();
    const flatListRef = React.useRef();
    const flatListOffsetX = React.useRef(0);
    const giftWidth = (0, native_base_1.useBreakpointValue)({
        base: giftWidthBase,
        md: giftWidthLg,
    });
    const onMerchBackPressed = () => {
        /*flatListRef.current.scrollToIndex({
            index: 0,
            animated: false,
        });*/
        flatListRef.current.scrollToOffset({
            offset: flatListOffsetX.current - giftWidth,
            animated: true,
        });
    };
    const onMerchNextPressed = () => {
        /*flatListRef.current.scrollToIndex({
            index: 1,
            animated: false,
        });*/
        //console.log(flatListRef.current);
        //console.log(flatListRef.current.__proto__);
        flatListRef.current.scrollToOffset({
            offset: flatListOffsetX.current + giftWidth,
            animated: true,
        });
    };
    const renderItem = ({ item }) => {
        return <TacticoItem item={item}/>;
    };
    if ((items?.length ?? 0) == 0)
        return <native_base_1.View></native_base_1.View>;
    return (<native_base_1.VStack>
			<native_base_1.HStack mt={10} alignItems="center">
				<native_base_1.Pressable onPress={onMerchBackPressed}>
					<native_base_1.Image alt="_" source={icons_1.default.icBack} width={20} height={20}/>
				</native_base_1.Pressable>
				<native_base_1.View flex={1}>
					<native_base_1.FlatList key={client?.id} width={giftWidth} showsHorizontalScrollIndicator={false} ref={flatListRef} horizontal data={items} renderItem={renderItem} onScroll={(event) => {
            const slideSize = event.nativeEvent.layoutMeasurement.width;
            const index = event.nativeEvent.contentOffset.x / slideSize;
            const roundIndex = Math.round(index);
            flatListOffsetX.current = event.nativeEvent.contentOffset.x;
            //console.log("event.nativeEvent.contentOffset:", event.nativeEvent.contentOffset.x);
            //console.log("roundIndex:", roundIndex);
        }}/>
				</native_base_1.View>
				<native_base_1.Pressable onPress={onMerchNextPressed}>
					<native_base_1.Image alt="_" source={icons_1.default.icBack} width={20} height={20} style={{
            transform: [{ rotate: "180deg" }],
        }}/>
				</native_base_1.Pressable>
			</native_base_1.HStack>
		</native_base_1.VStack>);
};
const TacticoItem = ({ item }) => {
    const giftWidth = (0, native_base_1.useBreakpointValue)({
        base: giftWidthBase,
        md: giftWidthLg,
    });
    return (<native_base_1.VStack alignItems="center">
			<native_base_1.Image alt="_" source={{ uri: item.icon, width: 70, height: 20 }} w={giftWidth - 10} h={30}/>
			<native_base_1.HStack w={giftWidth} justifyContent="center" alignItems="center">
				<native_base_1.VStack alignItems="center">
					<native_base_1.Text fontFamily={theme_1.Fonts.black} fontSize={{ base: 9, md: 11 }} lineHeight={"1rem"}>
						Meta
					</native_base_1.Text>
					<native_base_1.Text fontFamily={theme_1.Fonts.black} fontSize={{
            base: 18,
            md: 24,
        }} lineHeight={"1.1rem"}>
						{item.meta ?? " "}
					</native_base_1.Text>
				</native_base_1.VStack>
				<native_base_1.View background="black" w={1.7} h={30} mx={6}/>
				<native_base_1.VStack alignItems="center">
					<native_base_1.Text fontFamily={theme_1.Fonts.black} fontSize={{ base: 9, md: 11 }} lineHeight={"1rem"}>
						{theme_1.Str.advance}
					</native_base_1.Text>
					<native_base_1.Text fontFamily={theme_1.Fonts.black} fontSize={{
            base: 18,
            md: 24,
        }} lineHeight={"1.1rem"}>
						{item.avance ?? ""}
					</native_base_1.Text>
				</native_base_1.VStack>
			</native_base_1.HStack>
		</native_base_1.VStack>);
};
const styles = react_native_1.StyleSheet.create({
    container: {
        w: "100%",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#ffed00",
    },
    bottomLine: {
        height: 5,
        backgroundColor: "white",
    },
    imgHeaderLine: {
        width: 50,
        height: 5,
    },
    containerProfile: {
        flex: 1,
        flexDirection: "row",
        alignItems: "center",
    },
    containerProfileTexts: {
        marginEnd: 10,
        flex: 1,
    },
    txtProfileCredit: {
        color: theme_1.Colors.colorVividRed1,
        textTransform: "uppercase",
    },
    imgProfile: {
        borderRadius: 50,
    },
});
exports.default = exports.Header;
